export type DiscoveryPreferences = {
  region: string;
  service: string;
  date: string;
  budget: string;
  priority: string;
};

export function readDiscoveryPreferences(search: string, today: string): DiscoveryPreferences {
  const query = new URLSearchParams(search);
  const priority = query.get("priority") || "balanced";
  return {
    region: query.get("region") || "",
    service: query.get("service") || "",
    date: query.get("date") || today,
    budget: query.get("budget") || "",
    priority: ["balanced", "availability", "rating", "price", "experience"].includes(priority) ? priority : "balanced",
  };
}

export function discoveryQuery(preferences: DiscoveryPreferences): string {
  const query = new URLSearchParams({
    region: preferences.region.trim(), service: preferences.service.trim(),
    date: preferences.date, priority: preferences.priority,
  });
  if (preferences.budget.trim()) query.set("budget", preferences.budget.trim());
  return query.toString();
}

export function completeDiscoveryPreferences(preferences: DiscoveryPreferences): boolean {
  return Boolean(preferences.service.trim() && preferences.date);
}

export type DiscoveryCoverage = {
  checkedAt: string;
  sourceUpdatedAt: string | null;
  designerCount: number;
  serviceCount: number;
  missingRegionCount: number;
  regions: string[];
  services: string[];
};
